module.exports = __webpack_public_path__ + "static/media/sennheiser-momentum-true-wireless-2.8de87d27.jpg";